import styled, { css } from 'styled-components';

export const OptionBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 1em;
  margin: 0 1em;
  cursor: pointer;
  background-color: transparent;
  column-gap: 1em;

  @media (max-width: 768px) {
    margin: 0;
  }

  &:hover {
    background-color: #ffc72c;
  }

  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
  `}
`;

export const SelectedOptionBox = styled(OptionBox)`
  background-color: #e0e0e0;
`;

export const OptionsContainer = styled.div`
  margin: 2em;
  @media (max-width: 768px) {
    margin: 1em;
  }
`;

export const StrapColor = styled.p`
  font-size: 20px;
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.bold};
  `}
`;

export const StrapMaterial = styled.p`
  font-size: 16px;
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.regular};
  `}
`;

export const Slug = styled.p`
  @media (min-width: 768px) {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    margin-right: 2em;
  }
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.extraLight};
  `}
`;

export const StrapInfo = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;
